import axios from "axios";
import { clearLocalStorage } from "./Helpers";

const i18nextLang = 'i18nextLng';

const userLanguage = () => {
  return localStorage.getItem(i18nextLang) || "fa";
};

axios.interceptors.request.use(
  function (config) {
    config.headers["Content-Type"] = "application/json";
    if (
      !config.url.endsWith("/users/login") &&
      !config.url.includes("/users/checkNumber") &&
      !config.url.includes("/live-data/price")
    ) {
      config.headers["Authorization"] = localStorage.getItem("token");
      config.headers["Accept-Language"] = userLanguage();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
function takeOutUser() {
  clearLocalStorage();

  setTimeout(() => {
    return (window.location.href = "/app/login");
  }, 10);
}
// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response.status === 500 &&
      error.response.data.message === "invalid token"
    ) {
      if (window.location.href.includes("buy-sell/tether")) {
        return error.response;
      }
      // ========= Don't redirect to login if we are in landing
      takeOutUser();
      throw error;
    }
    if (
      error.response.status === 500 &&
      error.response.data.message === "jwt expired"
    ) {
      if (window.location.href.includes("buy-sell/tether")) {
        if (window.location.href.includes("buy-sell/tether")) {
          return error.response;
        }
      }
      // ========= Don't redirect to login if we are in landing
      takeOutUser();
      throw error;
    }
    if (error.response.status === 403 || error.response.status === 401) {
      // ========= Don't redirect to login if we are in landing
      if (!error.config.url.includes("/core/currency/find-all")) {
        if (window.location.href.includes("buy-sell/tether")) {
          if (window.location.href.includes("buy-sell/tether")) {
            return error.response;
          }
        }
        takeOutUser();
        throw error;
      }
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    throw error;
  }
);

const fetchUrl = async ({ url, method = "GET", body = {} }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: body,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
  try {
    debugger;
    const response = await axios({
      method: method,
      url: url,
      data: body,
    });
    return response;
  } catch (error) {
    debugger;
    return error;
  }
};

export default fetchUrl;
